import React from 'react';

import withAuthorization from './withAuthorization';
import {Navbar, Icon, Col,Card,CardTitle} from 'react-materialize'

const LandingPage = () =>
  <div>
    <Col m={6} s={12}>
      <Card className='blue-grey darken-1' textClassName='white-text' title='Card title' actions={[<a href='#'>This is a link</a>]}>
        I am a very simple card.
      </Card>
    </Col>
    <Card className='small'
      header={<CardTitle image='http://hotspot.engelsoft.com.br/images/portal/mesh-wave.jpg'>Card Title</CardTitle>}
      actions={[<a href='#'>This is a Link</a>]}>
      I am a very simple card. I am good at containing small bits of information. I am convenient because I require little markup to use effectively.
    </Card>
    <Card header={<CardTitle reveal image={"http://hotspot.engelsoft.com.br/images/portal/mesh-wave.jpg"} waves='light'/>}
      title="Card Title"
      reveal={<p>Here is some more information about this product that is only revealed once clicked on.</p>}>
      <p><a href="#">This is a link</a></p>
    </Card>
  </div>

const authCondition = (authUser) => !!authUser;

// export default LandingPage;

export default withAuthorization(authCondition)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/Landing.js